import Swiper from "swiper";
import bb from "blingblingjs";

const topSwiper = new Swiper(".js-el__pdp-featured-top", {
	loop : true
});

const bottomSwiper = new Swiper(".js-el__pdp-featured-bottom", {
	loop : true,
	effect: 'fade'
});


// If these swiper instances are present on the current page...

if(topSwiper.controller && bottomSwiper.controller ){

	topSwiper.controller.control = bottomSwiper;
	bottomSwiper.controller.control = topSwiper;

	bb(".js-fn__pdp-featured-next").on("click", () => {
		topSwiper.slideNext();
	});
	bb(".js-fn__pdp-featured-prev").on("click", () => {
		topSwiper.slidePrev();
	});

}